import React from 'react';
import styled from 'styled-components';

const CategoryContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin: 1rem 0;
    pointer-events: none; /* No interferir con clicks del contenedor padre */
`;

// Estilo basado en los botones del playground pero con Poppins y línea más delgada
const CategoryBadge = styled.span`
    padding: 0.5rem 1rem;
    border: 1px solid ${props => props.theme.body.headers};
    background: transparent;
    color: ${props => props.theme.body.headers};
    border-radius: 25px;
    font-size: 0.8rem;
    font-weight: 400;
    font-family: 'Poppins', sans-serif;
    cursor: ${props => props.clickable ? 'pointer' : 'default'};
    transition: all 0.3s ease;

    &:hover {
        background: ${props => props.clickable ? props.theme.body.headers : 'transparent'};
        color: ${props => props.clickable ? props.theme.body.background : props.theme.body.headers};
    }
`;

const CategoryDisplay = ({ 
    category, 
    onCategoryClick = null
}) => {
    if (!category) return null;

    return (
        <CategoryContainer>
            <CategoryBadge 
                clickable={!!onCategoryClick}
                onClick={() => onCategoryClick && onCategoryClick(category)}
            >
                {category}
            </CategoryBadge>
        </CategoryContainer>
    );
};

export default CategoryDisplay;